import {
  Box,
  DoughnutChart,
  Icon,
  Text,
  getThemeColor,
} from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { getReadableNumber } from '../../../utilities/strings/getReadableNumber'
import { DashboardCardMenu } from '../DashboardCardMenu/dashboard-card-menu.comp'

import * as Styles from './dashboard-percentage-card.styles'
import { DashboardPercentageCardProps } from './dashboard-percentage-card.types'

export const DashboardPercentageCard = ({
  title,
  icon,
  value,
  details,
  url,
  color,
  ...rest
}: DashboardPercentageCardProps) => {
  const theme = useTheme()

  return (
    <Styles.Card
      gap={3}
      padding={3}
      paddingTop={4}
      direction="column"
      width="100%"
      justifyContent="center"
      {...rest}
    >
      <DashboardCardMenu title={title} details={details} url={url} />

      <Box gap={2} alignItems="center" width="100%">
        <DoughnutChart
          totalValue={100}
          parts={[{ color: getThemeColor(color, theme), value }]}
          size={120}
          showTotalValue={false}
        />
        <Box direction="column" gap={2} flex={1}>
          <Box gap={2} alignItems="center" flexWrap="wrap">
            <Styles.IconContainer>
              <Icon name={icon} color={color} size={24} />
            </Styles.IconContainer>
            <Text fontWeight={500}>{title}</Text>
          </Box>

          <Box
            gap={2}
            alignItems="flex-end"
            justifyContent="space-between"
            width="100%"
          >
            <Box flex={1}>
              <Styles.CardValue>{getReadableNumber(value)}%</Styles.CardValue>
            </Box>
          </Box>
        </Box>
      </Box>
    </Styles.Card>
  )
}
